import { createFileRoute } from '@tanstack/react-router'
import { DashboardScreen } from '@web/app/features/dashboard'

export const Route = createFileRoute('/_index/dashboard')({
  component: DashboardScreen,
  staticData: {
    metaRoute: {
      title: 'Dashboard', 
      order: 3,
    },
  },
})